// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__IEkhk","right":"Footer_right__3rZix","buttons":"Footer_buttons__16mvm"};